export const UNCHANGED_GRAPH_STROCK_COLOR = 'rgba(0, 0, 0, 0.85)';
export const GAINERS_GRAPH_STROCK_COLOR = '#52c41a';
export const LOOSERS_GRAPH_STROCK_COLOR = '#cf1322';
export const HOVER_TEXT_BACKGROUND = '#fafafa';
